// extracted by mini-css-extract-plugin
export default {"img":"FilePreview_img__zuIeR","videoPlayer":"FilePreview_videoPlayer__QfzuY","audioPlayer":"FilePreview_audioPlayer__h-RoI"};